import { applyAetherFileEvent } from './aetherFileEvents.js'
import { applyAetherArtifactEvent } from './aetherProjectEvents.js'

function safeJsonParse(value) {
  try {
    return JSON.parse(value)
  } catch {
    return null
  }
}

export function parseSseEvent(raw) {
  const data = raw
    .split(/\r?\n/)
    .filter((line) => line.startsWith('data:'))
    .map((line) => line.slice(5).trimStart())
    .join('\n')
    .trim()
  if (!data) return null
  return safeJsonParse(data)
}

export function applyAetherEvent(acc, event) {
  applyAetherFileEvent(acc, event)
  applyAetherArtifactEvent(acc, event)
  if (event?.type === 'token' && event.content) acc.text += event.content
  if (event?.type === 'clarification' && event.content) acc.text += event.content
  if (event?.type === 'error') acc.error = event.error || event.content || 'Chat failed'
  if (event?.type === 'agent_switch' && event.agent) {
    acc.meta.agentName = event.agent
    acc.meta.agentBrand = event.agent === 'openclaw' ? 'OpenClaw' : 'Aether'
  }
}
